// Menu di lavoro: voci segnaposto in attesa del menu definitivo.
// Per aggiornare: sostituisci name/description/price in ogni voce.
const placeholder = () => ({ name: "", description: "", price: "" });

export const menuCategories = [
  { id: "antipasti", items: [placeholder(), placeholder(), placeholder()] },
  { id: "mare", items: [placeholder(), placeholder(), placeholder()] },
  { id: "vini", items: [placeholder(), placeholder(), placeholder()] },
  { id: "drink", items: [placeholder(), placeholder(), placeholder()] },
  { id: "dolci", items: [placeholder(), placeholder(), placeholder()] },
];
